module.exports = __webpack_public_path__ + "d369b03594c4fe397d2b64bc1bd2bc72.svg";